import React from "react";
import {
  CardBody,
  Row,
} from "reactstrap";

export default function EventLink({
  miceId,
}) {
  return (
    <CardBody>
      <Row>
        <a href={`https://face-recognition-app.sistemasinteegra.com.br/FaceCollectorAwsV2?public=true&eventId=${miceId}&guestId=123`} target="_blank">
          Link de acesso exemplo V2
        </a>
      </Row>
      <Row style={{ paddingTop: 10 }}>
        <a href={`https://face-recognition-app.sistemasinteegra.com.br/FaceCollectorAwsV3?public=true&eventId=${miceId}&guestId=123`} target="_blank">
          Link de acesso exemplo V3
        </a>
      </Row>
    </CardBody>
  )
}
